var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert alert-danger text-center space-box-alert-custom" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-b-md" },
        [
          _vm._v("\n    設定画面は"),
          _c(
            "router-link",
            {
              attrs: { to: { path: "/warehouse-amazon/multi-channel-service" } }
            },
            [_vm._v("こちら")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-b-md" }, [
      _vm._v("\n    マルチチャネルサービス設定が未提出です "),
      _c("br"),
      _vm._v(
        " セールモンスターへ出品する場合は、マルチチャネルサービス設定のご提出が必要です。\n  "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1892714a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1892714a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoMultiChannelService.vue
// module id = null
// module chunks = 